module.exports = __webpack_public_path__ + "img/Airbnb-Hybrid-Stretch-Relax.2fa9cb29.jpg";